import { useState } from "react";
import { useForm } from "react-hook-form";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import useUser from 'hooks/useUser';
import { buildJsons, insertJsons, subirExceles, transformToCsv } from 'services/series';
// import BlinkBlurRectangles from "utilities/BlinkBlur";
import Swal from "sweetalert2";
import { BlinkBlurRectangles, BlinkBlurCubes } from "utilities/BlinkBlur/BlinkBlur";

const STATUS_IDLE = 0

export const ModalExceles = ({ modal, toggle, fetchData }) => {
    const [files, setFiles] = useState([])
    const { tokenFull, IdUser } = useUser();
    const [status, setStatus] = useState(STATUS_IDLE)
    const [isVisible, setIsVisible] = useState(false);
    const [isVisibleProcessing, setIsVisibleProcessing] = useState(false);
    const [isVisibleInput, setIsVisibleInput] = useState(true);
    const [isDisabled, setIsDisabled] = useState(false);

    const {
        register, 
        handleSubmit, 
        formState:{errors},
        setError,
        reset
        } = useForm({
        defaultValues:{
            archivos: files,
        },
        mode: 'onChange', 
    })

    const onSubmit = handleSubmit(async (data,e) => {
        e.preventDefault();
        setIsDisabled(true);
        if(data.archivos.length===0){
            setError('archivos',{
                message: 'Se requiere al menos un archivo'
            })
            setIsDisabled(false);
        }else{
            setIsVisible(true);
            const formData = new FormData();
            // Agregar archivos seleccionados al FormData
            for (let i = 0; i < files.length; i++) {
                formData.append('archivos[]', files[i]); // Usa 'archivos[]' para permitir múltiples archivos
            }
            // formData.append('files', data);
            formData.append('IdUser', IdUser);
            const result = await subirExceles(formData, tokenFull);
            setIsVisible(false);
            if(result.response){
                if(result.response.estado==='Ok'){
                    setIsVisibleInput(false);
                    setIsVisibleProcessing(true);
                    const dataTransform = await transformToCsv(tokenFull);
                    if(dataTransform.response.estado==='Ok'){
                        const dataJsons = await buildJsons(tokenFull, IdUser);
                        if(dataJsons.response.estado==='Ok'){
                            // if(dataJsons.response.mensaje.includes('.json')){
                            if(isValidDate(dataJsons.response.mensaje)){
                                const dataInsert = await insertJsons(tokenFull, dataJsons.response.id, dataJsons.response.mensaje);
                                
                                reset();
                                fetchData();
                                // bton enviar
                                setIsDisabled(false);
                                // animacion de porcesado
                                setIsVisibleProcessing(false);
                                // input de cargado
                                setIsVisibleInput(true);
                                Swal.fire({
                                    icon: 'success',
                                    buttonsStyling: true,
                                    text: dataInsert,
                                    confirmButtonColor: '#ed7100',
                                })
                            }else{
                                reset();
                                fetchData();
                                setIsDisabled(false);
                                setIsVisibleProcessing(false);
                                setIsVisibleInput(true);
                                Swal.fire({
                                    icon: 'success',
                                    buttonsStyling: true,
                                    text: dataJsons.response.mensaje,
                                    confirmButtonColor: '#ed7100',
                                })
                            }
                        }
                    }
                        // Swal.fire({
                        //         icon: "success",
                        //         title: '<h5 style="color:#A5DC86">ACTUALIZADO</h5>',
                        //         text: result.response.mensaje,
                        //         showConfirmButton: false,
                        //         timer: 2500
                        // });
                }else{
                    setIsDisabled(false);
                    Swal.fire({
                        icon: 'error',
                        buttonsStyling: true,
                        title: '<h5 style="color:#f27474">ERROR</h5>',
                        text: result.response.mensaje,
                        confirmButtonColor: '#ed7100',
                    })
                }
            }
            if(result.errors){
                setIsDisabled(false);
                for(const property in result.errors){
                    setError(property.split('.')[0],{
                        message: result.errors[property]
                    })
                }
            }
        }
    })

    // const uploadFiles = (data)=> {
    //     setStatus(STATUS_UPLOADING)

    //     fetch(API_URL, {
    //         method: API_METHOD,
    //         body: data,
    //     })
    //     .then((res) => res.json())
    //     .then((data) => console.log(data))
    //     .catch((err) => console.error(err))
    //     .finally(() => setStatus(STATUS_IDLE))
    // }

    // const packFiles = (files)=> {
    //     const data = new FormData()
    //     [...files].forEach((file, i) => {
    //         data.append(`file-${i}`, file, file.name)
    //     })
    //     return data
    // }

    // const handleUploadClick = () => {
    //     if (files.length) {
    //         const data = packFiles(files)
    //         uploadFiles(data)
    //     }
    // }

    function isValidDate(dateString) {
        const formattedDateString = dateString.replace(/\./g, ":");
        const date = new Date(formattedDateString);
        return !isNaN(date.getTime());
    }

    const renderFileList = () => (<ol>
        {[...files].map((f, i) => (
            <li key={i}>{f.name}</li>
            // <li key={i}>{f.name} - {f.type}</li>
        ))}
    </ol>)

    return(
        <Modal isOpen={modal} toggle={toggle} backdrop="static" keyboard={false}>
            <form onSubmit={onSubmit} encType="multipart/form-data">
                <ModalHeader toggle={toggle}>
                    Carga de archivos excel
                </ModalHeader>
                <ModalBody>
                    <div className="row">
                        <div className='col-md-6 text-center mx-auto'>
                            <div style={{ display: isVisibleInput ? '' : 'none' }}>
                                <label>
                                    Selecciona todos los archivos al dar click.
                                </label>
                                <input 
                                    type="file" 
                                    className="form-control"
                                    {...register('archivos',{
                                        validate:{
                                            lessThan30MB:(files)=>{
                                                for(let i = 0;i < files.length; i++){
                                                    if(files[i].size > 30000000){
                                                        return 'Cada archivo debe pesar menos de 30MB';
                                                    }
                                                }
                                            },
                                            acceptedFormats:(files) =>{
                                                for(let i = 0;i < files.length; i++){
                                                    if(!['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'].includes(files[i].type)){
                                                        return 'Solo se permiten archivos .xlsx';
                                                    }
                                                }
                                            }
                                        }
                                    })} 
                                    accept=".xlsx" 
                                    multiple
                                    onChange={(e)=>setFiles(e.target.files)}
                                    required
                                />
                                    {renderFileList()}
                                    {errors.archivos && <span className='text-danger'>{errors.archivos.message}</span>}
                                <BlinkBlurRectangles 
                                    color="#f58705" 
                                    size="medium" 
                                    text="Este proceso puede tomar algunos minutos...!" 
                                    textColor="#ffffff" 
                                    speed={500} // Velocidad de cambio de iluminación (en milisegundos)
                                    isVisible={isVisible} // Pasamos la visibilidad al componente
                                />
                            </div>
                            <BlinkBlurCubes 
                                isVisible={isVisibleProcessing}
                            />
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button type='submit' className='btn btn-primary' disabled={isDisabled}>Envíar</Button>
                </ModalFooter>
            </form>
        </Modal>
    );
};